<template>
    <el-button v-if="this.isTowerCo() && this.isManager() && this.canAccess('project|maintenance|finance')" icon="fa fa-trash-alt" aria-label="Delete equipment" @click="deleteEntry()" size="small" type="danger" circle></el-button>
</template>

  <script>
  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],
    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'equiptable'
      },
      // XOL-596 (completed steps): the request step the delete is made from (step 2).
      actionStepId: {
        type: Number,
        default: null
      }
    },


    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/assets', this.rowData.category +
         ' / ' + this.rowData.type +
          (this.rowData.subType ? '/ ' + this.rowData.subType : '') +
           ' ' + (this.rowData.name ? ' / ' + this.rowData.name : ''),
           this.onDelete,
           true, null, 'Yes',
           // The step context rides in the DELETE's JSON body; a refusal (403 step_completed)
           // is reported to the request drawer instead of a "Delete failed" toast.
           this.actionStepId ? { body: { actionStepId: this.actionStepId }, what: 'equipmentDelete' } : null)
      },

      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }

    }

  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
